module.exports = __webpack_public_path__ + "c68b034fbe724c202a9374fb4f3b9ea6.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/12_column_medium_x1/public/history/8.jpg
// module id = 296
// module chunks = 0